export default function classNames(...values) {
    return values
        .flatMap((value) => {
            if (!value) {
                return [];
            }
            if (typeof value === "string") {
                return value.trim();
            }
            if (Array.isArray(value)) {
                return value;
            }
            if (typeof value === "object") {
                return Object.entries(value)
                    .filter(([, active]) => Boolean(active))
                    .map(([key]) => key);
            }
            return String(value).trim();
        })
        .filter(Boolean)
        .join(" ");
}
